import { Outlet } from 'react-router-dom';

const Layout = () => {
  return (
    <div>
      <div className='bg-gradient-to-t from-primary-200 to-primary-100 pb-2 pt-8 text-center md:pb-0'>
        <div className=' text-xl font-bold md:text-2xl lg:text-4xl'>
          Church of{' '}
          <span className='whitespace-nowrap'>
            Our Lady of Perpetual Succour
          </span>
        </div>
        <div className=' text-lg font-normal text-gray-500 md:text-xl lg:text-2xl'>
          Catechism Registration for 2027
        </div>
      </div>

      <div className='relative'>
        <div
          className='absolute w-full bg-cover bg-center bg-no-repeat'
          style={{
            zIndex: '-1',
            aspectRatio: '1440/200',
          }}
        >
          <svg id='visual' viewBox='0 0 1440 200' preserveAspectRatio='none'>
            <rect x='0' y='0' width='1440' height='200' fill='#FFF'></rect>
            <path
              d='M0 97L34.3 99C68.7 101 137.3 105 205.8 100C274.3 95 342.7 81 411.2 76.5C479.7 72 548.3 77 617 79.5C685.7 82 754.3 82 823 79.7C891.7 77.3 960.3 72.7 1028.8 76.7C1097.3 80.7 1165.7 93.3 1234.2 95.7C1302.7 98 1371.3 90 1405.7 86L1440 82L1440 0L1405.7 0C1371.3 0 1302.7 0 1234.2 0C1165.7 0 1097.3 0 1028.8 0C960.3 0 891.7 0 823 0C754.3 0 685.7 0 617 0C548.3 0 479.7 0 411.2 0C342.7 0 274.3 0 205.8 0C137.3 0 68.7 0 34.3 0L0 0Z'
              className='fill-1'
            ></path>
            <path
              d='M0 86L34.3 82.7C68.7 79.3 137.3 72.7 205.8 71.2C274.3 69.7 342.7 73.3 411.2 77C479.7 80.7 548.3 84.3 617 81C685.7 77.7 754.3 67.3 823 67.3C891.7 67.3 960.3 77.7 1028.8 76.5C1097.3 75.3 1165.7 62.7 1234.2 62.5C1302.7 62.3 1371.3 74.7 1405.7 80.8L1440 87L1440 0L1405.7 0C1371.3 0 1302.7 0 1234.2 0C1165.7 0 1097.3 0 1028.8 0C960.3 0 891.7 0 823 0C754.3 0 685.7 0 617 0C548.3 0 479.7 0 411.2 0C342.7 0 274.3 0 205.8 0C137.3 0 68.7 0 34.3 0L0 0Z'
              className='fill-2'
            ></path>
            <path
              d='M0 45L34.3 43.2C68.7 41.3 137.3 37.7 205.8 39.5C274.3 41.3 342.7 48.7 411.2 53.5C479.7 58.3 548.3 60.7 617 62.2C685.7 63.7 754.3 64.3 823 62.5C891.7 60.7 960.3 56.3 1028.8 51.5C1097.3 46.7 1165.7 41.3 1234.2 42.7C1302.7 44 1371.3 52 1405.7 56L1440 60L1440 0L1405.7 0C1371.3 0 1302.7 0 1234.2 0C1165.7 0 1097.3 0 1028.8 0C960.3 0 891.7 0 823 0C754.3 0 685.7 0 617 0C548.3 0 479.7 0 411.2 0C342.7 0 274.3 0 205.8 0C137.3 0 68.7 0 34.3 0L0 0Z'
              className='fill-3'
            ></path>
            <path
              d='M0 27L34.3 29C68.7 31 137.3 35 205.8 36.7C274.3 38.3 342.7 37.7 411.2 35.8C479.7 34 548.3 31 617 28.5C685.7 26 754.3 24 823 24.8C891.7 25.7 960.3 29.3 1028.8 30.7C1097.3 32 1165.7 31 1234.2 29.5C1302.7 28 1371.3 26 1405.7 25L1440 24L1440 0L1405.7 0C1371.3 0 1302.7 0 1234.2 0C1165.7 0 1097.3 0 1028.8 0C960.3 0 891.7 0 823 0C754.3 0 685.7 0 617 0C548.3 0 479.7 0 411.2 0C342.7 0 274.3 0 205.8 0C137.3 0 68.7 0 34.3 0L0 0Z'
              className='fill-4'
            ></path>
          </svg>
        </div>
      </div>

      <div className='mt-4 flex items-center justify-center sm:mt-12 lg:mt-16'>
        <div className='w-11/12 md:w-3/4'>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
